import React, { useEffect, useState } from "react";
import "../../style/player.css";
import { useParams } from "react-router-dom";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";
import RootLayout from "../layout";
import { Paper } from "../../components/legacy-ui/materialCompat";
import SpitialPlayer from "../../components/player/wrapper";
import { orderHlsFirst } from "../../player/sourceSelection";

export function getTrailerSources(trailer) {
  return orderHlsFirst(trailer);
}

async function getData(params) {
  try {
    const decodedUrl = decodeURIComponent(params.slug);

    const response = await httpService.get(
      getCMSApiRoute(
        "content?" +
        new URLSearchParams({
          slug: decodedUrl,
          pageIndex: 1,
          pageNumber: 1,
        })
      )
    );

    const { data } = response.data;

    if (response.status !== 200) return response.status;

    return data?.results?.[0];
  } catch (error) {
    console.log(error);
    return {};
  }
}

async function getMoviesData(params, searchParams) {
  try {
    const data = await getData(params, searchParams);

    if (data === 400)
      return {
        rawData: 400,
      };

    if (!data) {
      return {
        movie: "",
        vast: "",
        hasErr: true,
        message: "محتوا با مشخصات مورد نظر یافت نشد",
      };
    }

    let { trailer } = data;
    const trailerSourceList = getTrailerSources(trailer);
    const trailerSources =
      trailerSourceList.length > 0 ? { sources: trailerSourceList } : null;

    return {
      movie: trailerSources,
      hasErr: trailerSourceList.length === 0,
      message:
        trailerSourceList.length === 0
          ? "نسخه قابل پخش پیش نمایش در دسترس نیست"
          : undefined,
      rawData: data,
      isTrailer: true, // Flag to indicate this is a trailer
      posters: data?.contentPhotos?.filter((x) => x.type === "videoPlayerCover") || [],
      hotPoints: [],
    };
  } catch (error) {
    console.log(error);
    console.log(`Error on Player SSR Init: ${error}`);
    return {
      message: error.message,
      hasErr: true,
    };
  }
}

const TrailerPlayer = () => {
  const params = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getMoviesData(params, params).then((data) => {
      setData(data);
      setLoading(false);
    });
  }, [params]);

  if (loading)
    return (
      <main className="legacy-player-loading-screen">
        <div className="legacy-player-loading-cell">
          <img src="/three-dots.svg" alt="loading..." />
        </div>
      </main>
    );

  if (data && data.rawData) {
    return (
      <RootLayout>
        <main className="w-full" dir="ltr">
          <SpitialPlayer data={data} />
        </main>
      </RootLayout>
    );
  } else {
    return (
      <main className="w-full h-screen flex items-start md:items-center justify-center bg-black dark">
        <Paper className="p-5">
          {
            "خطا در دریافت اطلاعات محتوا، لطفا اتصال اینترنت خود را بررسی کرده و سپس مجددا تلاش فرمائید"
          }
        </Paper>
      </main>
    );
  }
};
export default TrailerPlayer;
